import NProgress from 'nprogress';
import axiosInstance from "../../../../axiosInstance";
import { HRMS_EMPLOYEE_API_URL } from "../../../Constants/baseConstant";
import { getDomain, getUserId } from "../../Base/helper/baseFunctions";
import { toast } from 'react-toastify';

// ------- Ecms Exit Employee -----
export const GetExitEmployeesHelper = async () => {
    NProgress.start();
    return await axiosInstance(`/ecms/getExitEmployees`, {
        method: "POST",
        baseURL: HRMS_EMPLOYEE_API_URL,
        data: {
            domain_name: getDomain(),
            user_id: getUserId(),
            ats_work_location_json: null
        }
    })
    .then((res) => {
        NProgress.done();
        return { message: "Exit employees retrieved successfully", hasError: false, data: res?.data }
    }).catch(err => {
        NProgress.done();
        return { message: "Unable to retrieve exit employees", hasError: true, data: err?.response?.data }
    });
};

export const GetAutoCalculatedLWDHelper = async (params) => {
    NProgress.start();
    return await axiosInstance(`/ecms/employee/getAutoCalculatedLWD`, {
        method: "POST",
        baseURL: HRMS_EMPLOYEE_API_URL,
        data: {
            domain_name: getDomain(),
        }
    })
    .then((res) => {
        NProgress.done();
        return { message: "Exit employees retrieved successfully", hasError: false, data: res?.data }
    }).catch(err => {
        NProgress.done();
        return { message: "Unable to retrieve exit employees", hasError: true, data: err?.response?.data }
    });
};

export const GetOneExitEmployeesHelper = async (params) => {
    NProgress.start();
    return await axiosInstance(`/ecms/employee/getExitEmployee`, {
        method: "POST",
        baseURL: HRMS_EMPLOYEE_API_URL,
        data: {
            domain_name: getDomain(),
            employee_fk: params?.employee_fk
        }
    })
    .then((res) => {
        NProgress.done();
        return { message: "Exit employees retrieved successfully", hasError: false, data: res?.data }
    }).catch(err => {
        NProgress.done();
        return { message: "Unable to retrieve exit employees", hasError: true, data: err?.response?.data }
    });
};

export const updateEmployeeExitRequestHelper = async (params) => {
    toast.dismiss();
    toast.info("Saving...");
    return await axiosInstance(`/ecms/employee/employeeExitRequest`, {
        method: "PUT",
        baseURL: HRMS_EMPLOYEE_API_URL,
        data: {
            domain_name: getDomain(),
            user_id: getUserId(),
            employee_fk:params?.employee_fk,
            exit_type:params?.exit_type,
            personal_email:params?.personal_email || "",
            personal_phone:params?.personal_phone || null,
            lwd:params?.lwd,
            feedback_text:params?.feedback_text,
            feedback_no:params?.feedback_no,
            exit_reason_configuration_fk:params?.exit_reason_configuration_fk,
            request_type:params?.request_type,
        }
    })
    .then((res) => {
        toast.dismiss();
        toast.success("Exit initiated successfully");
        return { message: "Exit initiated successfully", hasError: false, data: res?.data }
    }).catch(err => {
        toast.dismiss();
        toast.error(err?.response?.data?.error?.[0]?.message);
        return { message: "Unable to initiated exit", hasError: true, data: err?.response?.data }
    });
};

// deleteExitRequest
export const DeleteExitRequestHelper = async (params) => {
    toast.dismiss();
    toast.info(params?.action_type === "withdra" ? "Withdrawing resignation..." : "Rejecting...");
    return await axiosInstance(`/ecms/employee/deleteExitRequest`, {
        method: "DELETE",
        baseURL: HRMS_EMPLOYEE_API_URL,
        data: {
            domain_name: getDomain(),
            employee_fk: params?.employee_fk,
            entry_type: params?.entry_type  // withdrawal / rejected
        }
    })
    .then((res) => {
        toast.dismiss();
        toast.success( params?.action_type === "withdra" ? "Resignation withdrawn successfully" : "Exit removed successfully");
        return { message: "Exit removed successfully", hasError: false, data: res?.data }
    }).catch(err => {
        toast.dismiss();
        toast.error(err?.response?.data?.error?.[0]?.message);
        return { message: "Unable to remove asset", hasError: true, data: err?.response?.data }
    });
};

export const updateEmployeeLwdHelper = async (params) => {
  toast.dismiss();
  toast.info("Updating...");
  return await axiosInstance(`/ecms/employee/updateLWD`, {
    method: "PUT",
    baseURL: HRMS_EMPLOYEE_API_URL,
    data: {
      domain_name: getDomain(),
      lwd: params?.lwd,
      employee_fk: params?.employee_fk,
    },
  })
    .then((res) => {
      toast.dismiss();
      toast.success("Last Working Date updated successfully");
      return {
        message: "Last Working Date updated successfully",
        hasError: false,
        data: res?.data,
      };
    })
    .catch((err) => {
      toast.dismiss();
      toast.error(err?.response?.data?.error?.[0]?.message || "Failed to update Last Working Date");
      return {
        message: "Unable to update Last Working Date",
        hasError: true,
        data: err?.response?.data,
      };
    });
};
// getEcmsGuideline
export const GetEcmsGuidelineHelper = async (params) => {
    NProgress.start();
    return await axiosInstance(`/ecms/getEcmsGuideline`, {
        method: "POST",
        baseURL: HRMS_EMPLOYEE_API_URL,
        data: {
            domain_name: getDomain(),
        }
    })
    .then((res) => {
        NProgress.done();
        return { message: "Guideline retrieved successfully", hasError: false, data: res?.data }
    }).catch(err => {
        NProgress.done();
        return { message: "Unable to retrieve guideline", hasError: true, data: err?.response?.data }
    });
};

export const UpdateECMSGuidelinesHelper = async (params) => {
    toast.dismiss();
    toast.info("Updating...");
    return await axiosInstance(`/ecms/updateEcmsGuideline`, {
        method: "PUT",
        baseURL: HRMS_EMPLOYEE_API_URL,
        data: {
            domain_name: getDomain(),
            user_empid: getUserId(),
            ecms_guideline: params?.ecms_guideline,
        }
    })
    .then((res) => {
        toast.dismiss();
        toast.success("Guideline updated successfully");
        return { message: "Guideline updated successfully", hasError: false, data: res?.data }
    }).catch(err => {
        toast.dismiss();
        toast.error(err?.response?.data?.error?.[0]?.message);
        return { message: "Unable to update guideline", hasError: true, data: err?.response?.data }
    });
};